'use strict';

var i18n = require('./i18n');
var envHelper = require('./envHelper');

var API_BASEURL = 'https://api.mockplus.cn/v7';
if (envHelper.isEn) {
  API_BASEURL = 'https://api.mockplus.com/v6';
} else if (envHelper.isJp) {
  API_BASEURL = 'http://jpapi.mockplus.com/v6';
}

if (window.isDev) {
  API_BASEURL = "http://192.168.2.88:8081/v3";
}

function get(url, data, onSuccess, onFailed) {
  $.get(API_BASEURL + url, data).done(function (res) {
    onSuccess(res);
  }).fail(function (res) {
    console.error(res);
    if (onFailed) {
      onFailed('Network Error!');
    }
    // actionHelper.dispatchAjaxFail(res, dispatch);
  });
}

function post(url, data, onSuccess, onFailed) {
  $.ajax({
    url: API_BASEURL + url,
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(data),
    dataType: 'json'
  }).done(onSuccess).fail(function (res) {
    console.log(res);
  }).fail(function (res) {
    console.log(res);
    if (onFailed) {
      onFailed('Network Error!');
    }
    // actionHelper.dispatchAjaxFail(res, dispatch);
  });
}

function loadResource(path, cb, disableFollow) {

  var params;
  if (envHelper.isEnOrJp) { // AWS 使用 withCredentials 的时候有问题，所以需要区分开
    params = {
      url: path,
      dataType: 'text'
    };
  } else {
    params = {
      url: path,
      dataType: 'text',
      xhrFields: {
        withCredentials: true
      }
    };
  }
  $.ajax(params).done(function (data, status, jqXHR) {
    if (jqXHR.status === 201) {
      if (!disableFollow) {
        loadResource(data, cb, true);
      } else {
        cb('Sorry, fail to load data.', '', jqXHR.status);
      }
    } else {
      cb(null, data, jqXHR.status);
    }
  }).fail(function (jqXHR) {
    cb({ message: i18n.get('REQUEST_SOURCE_ERROR') }, '', jqXHR.status);
  });
}

module.exports = {
  get: get,
  post: post,
  loadResource: loadResource
};



// WEBPACK FOOTER //
// ./src/helper/apiHelper.js